import { getTraderDeposits } from 'api/rest/traders/getTraderDeposits';
import { PaginationRequest } from 'data/common/models';

import {
  SortDirection,
  TraderDepositPaginationFilters,
  TraderDepositStatus,
} from '../models/TraderDeposit';

export const getDepositsWithDefaultStatuses =
  (statuses: TraderDepositStatus[], sortDirection: SortDirection = 'desc') =>
  async ({
    status,
    ...request
  }: PaginationRequest<TraderDepositPaginationFilters>) => {
    return getTraderDeposits({
      ...request,
      status: status ? status : statuses,
      sortDirection,
    });
  };
